// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICreateToken
 */
export interface ICreateToken {
    /**
     * 
     * @type {string}
     * @memberof ICreateToken
     */
    fd_customer_id: string;
}

/**
 * Check if a given object implements the ICreateToken interface.
 */
export function instanceOfICreateToken(value: object): value is ICreateToken {
    if (!('fd_customer_id' in value) || value['fd_customer_id'] === undefined) return false;
    return true;
}

export function ICreateTokenFromJSON(json: any): ICreateToken {
    return ICreateTokenFromJSONTyped(json, false);
}

export function ICreateTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateToken {
    if (json == null) {
        return json;
    }
    return {
        
        'fd_customer_id': json['fdCustomerId'],
    };
}

export function ICreateTokenToJSON(json: any): ICreateToken {
    return ICreateTokenToJSONTyped(json, false);
}

export function ICreateTokenToJSONTyped(value?: ICreateToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fdCustomerId': value['fd_customer_id'],
    };
}

